import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { AuthWrapped } from '~/modules/navigation/components'

import {
  FinanceReportPage,
  InvoicesReportPage,
  MarketingReportPage,
  BusinessMetricsReportPage,
  OnboardingReportPage,
} from '~/modules/reports/view'

export const PATH = {
  FINANCE_REPORT: 'finance-report',
  INVOICES_REPORT: 'invoices-report',
  MARKETING_REPORT: 'marketing-report',
  BUSINESS_METRICS: 'business-metrics',
  ONBOARDING_REPORT: 'onboarding-report',
}

export const ReportsRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('REPORTS')
  return (
    <Routes>
      <Route path={PATH.FINANCE_REPORT} element={<AuthWrapped component={FinanceReportPage} canAccess={canAccess} />} />
      <Route
        path={PATH.INVOICES_REPORT}
        element={<AuthWrapped component={InvoicesReportPage} canAccess={canAccess} />}
      />
      <Route
        path={PATH.MARKETING_REPORT}
        element={<AuthWrapped component={MarketingReportPage} canAccess={canAccess} />}
      />
      <Route
        path={PATH.BUSINESS_METRICS}
        element={<AuthWrapped component={BusinessMetricsReportPage} canAccess={canAccess} />}
      />
      <Route
        path={PATH.ONBOARDING_REPORT}
        element={<AuthWrapped component={OnboardingReportPage} canAccess={canAccess} />}
      />
      <Route path="/" element={<FinanceReportPage />} />
    </Routes>
  )
}

export const reportsLinks = {
  financeReportLink: () => `/${PATH.FINANCE_REPORT}`,
  invoicesReportLink: () => `/${PATH.INVOICES_REPORT}`,
  marketingReportLink: () => `/${PATH.MARKETING_REPORT}`,
  businessMetricsLink: () => `/${PATH.BUSINESS_METRICS}`,
  onboardingDataReportLink: () => `/${PATH.ONBOARDING_REPORT}`,
}
